import * as _ from 'lodash'
import {ASync} from "../PA.Core/Basic/ASync";
import {EventBO, IEventCopyOptions} from "../PA.TPM.BusinessObjects/EventBO";
import {IHaveEvents} from "../PA.TPM.Core/PA.TPM.IF.Aspects";
import {IDateRange, IMessageProvider, IProgressProvider, MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {ProgressProvider} from "../PA.Core/Basic/Progress";
import {TagBag} from "../PA.Utils/TagBag";
import {
  WB_DomainItemRow,
  WB_EventSpendPrdGrpRedistribRow,
  WB_ProductGroupRow,
  WB_SpendAllocationRuleItemRow, WB_SpendAllocationRuleRow,
  WB_TagRelationshipRow,
  WB_TagRow
} from "../PA.Core/PAdbSchemaRows";
import {
  Actual_Volume_Method_Anchor,
  Auto_Anchor_Policy_Auto,
  Auto_Anchor_Policy_Manual
} from "../PA.TPM.Core/TPM.Constants";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {IAutoAnchorManager} from "./PA.TPM.Services.IF";
import {MessageProvider} from "../PA.Core/Basic/Messages";
import {esWB_Spend_Allocation_Rule, esWB_Spend_Allocation_Rule_Item} from "../PA.Core/PAdbSchema";
import {Domain_getItems} from '../PA.Core/PAdbUtils';


export interface IAutoAnchorOptions {
    ConfirmActions?: (actions: {AnchorGroups?: IAnchorGroup[], AutoAnchorDeletes?: EventBO[]}) => Promise<{AnchorGroups?: IAnchorGroup[], AutoAnchorDeletes?: EventBO[]}>
}


//<editor-fold desc="Messages">

const msgNotLoaded = {type: MessageType.Warning, code: "NotLoaded", description: "Plan not Loaded",title: "Plan not Loaded"}
const msgPlanNotLoaded = {type: MessageType.Warning, code: "EmptyPlan", description: "Plan is Empty",title: "Plan is Empty"}
const msgNoAnchorGroups = {type: MessageType.Information, code: "NoAnchorGroups",  description: "No Anchor Groups detected", title: "No Anchor Groups detected" }
const msgAnchorOverlappingManualAnchors = {type: MessageType.Information, code: "ManualAnchorsOverlap",  description: "Anchor(s) overlapping Manual Anchor", title: "Anchor(s) overlapping Manual Anchor" }

//</editor-fold>


interface IAnchorGroup {
   StartMerchEvent: EventBO
   MerchEvents:       {[id: number]: EventBO},
   OverlappingEvents: {[id: number]: EventBO},

  RankMetricValue: number,
  GroupInStoreRange: IDateRange,
  GroupProductGroups: WB_ProductGroupRow[],
  SourceSyncId: string

  // Sync
  AutoAnchorBO: EventBO
}




export class AutoAnchorManager
  implements IAutoAnchorManager {
  private _eventCollection: IHaveEvents = undefined
  private _progressProvider: IProgressProvider = undefined
  private _messageProvider: IMessageProvider = undefined

  private _bLoaded: boolean = false
  private _tagBag: TagBag = undefined
  private _merchTags: WB_TagRow[] = []
  private _edlpTags: WB_TagRow[] = []
  private _edlcTags: WB_TagRow[] = []
  private _otherTags: WB_TagRow[] = []
  private _spendAllocationRules: WB_SpendAllocationRuleRow[] = []
  private _spendAllocaitonRuleItems: WB_SpendAllocationRuleItemRow[] = []
  private _spendAllocationDomainItems: WB_DomainItemRow[] = []

  constructor(ec: IHaveEvents) {

    this._eventCollection = ec
    this._progressProvider = new ProgressProvider()
    this._messageProvider = new MessageProvider()

    this._tagBag = new TagBag({dbContext: ec.dbContext})

    this.AutoAnchorManagerOnLoadComplete

  }

  get bAutoAnchorManagerOnLoadCompleted(): boolean {
    return this._bLoaded
  }

  get AutoAnchorManagerOnLoadComplete(): Promise<boolean> {

    const self = this

    return new Promise<boolean>((resolve, error) => {


      self._tagBag.OnIHaveTagsLoaded
        .then((res) => {

          let tagGroupType: WB_TagRow = _.first(_.filter(self._tagBag.AllTags, (aTag: WB_TagRow) => {
            return aTag.cif.TAG_ID == "Type"
          }))

          if (!_.isEmpty(tagGroupType)) {
            let arrTypeTags = _.filter(_.map(tagGroupType.WB_TagRelationshipRows_Children, (aTagRel: WB_TagRelationshipRow) => {
              return aTagRel.WB_TagRowChild
            }), (aTag) => {
              return !_.isEmpty(aTag)
            })
            self._merchTags = <any> _.filter(arrTypeTags, (aTag: WB_TagRow) => {
              return aTag.cif.TAG_NUM_VALUE == 1
            })
            self._edlpTags = <any> _.filter(arrTypeTags, (aTag: WB_TagRow) => {
              return aTag.cif.TAG_NUM_VALUE == 2
            })
            self._edlcTags = <any> _.filter(arrTypeTags, (aTag: WB_TagRow) => {
              return aTag.cif.TAG_NUM_VALUE == 3
            })
            self._otherTags = <any> _.filter(arrTypeTags, (aTag: WB_TagRow) => {
              return aTag.cif.TAG_NUM_VALUE == 4
            })
          }

          // Get Spend Allocation Rules
          return self._eventCollection.dbContext.findAll(esWB_Spend_Allocation_Rule, {}, {with: [esWB_Spend_Allocation_Rule_Item]})

        }).then((res) => {

        self._spendAllocationRules = res
        self._spendAllocaitonRuleItems = _.flatMap(self._spendAllocationRules, (a) => {
          return a.WB_SpendAllocationRuleItemRows
        })
        self._spendAllocaitonRuleItems = _.orderBy(self._spendAllocaitonRuleItems, (a) => {
          return a.cif.EVALUATION_ORDER
        })

        // Get Domain Values for Spend Allocation Domain
        return Domain_getItems(self._eventCollection.dbContext, ["RedistributionBasis"])

      }).then((arrDomItems) => {
        self._spendAllocationDomainItems = arrDomItems
        self._bLoaded = true
        resolve(true)
      })
        .catch((err) => {
          error(err)
        })

    })

  }

  get AnchorProgressProvider(): IProgressProvider {
    return this._progressProvider
  }

  get AnchorMessageProvider(): IMessageProvider {
    return this._messageProvider
  }


  AutoAnchor(options?: IAutoAnchorOptions): Promise<void> {
    const self = this

    let opts: IAutoAnchorOptions = _.defaults(options || {}, {})

    self.AnchorProgressProvider.start("Auto Anchoring..")
    self.AnchorMessageProvider.clearMessages()

    if (!self._bLoaded) {
      self.AnchorMessageProvider.addMessage(msgNotLoaded)
      self.AnchorProgressProvider.finish()
      return ASync.resolve()
    }
    let calcEventsOther: { [idx: number]: EventBO } = {}
    let calcEventsAutoAnchors: { [idx: number]: EventBO } = {}

    return new Promise<void>((resolve, error) => {

      let evts = _.filter(self._eventCollection.Events, (aEvt) => {
        return !aEvt.bIsDeleted
      })

      if (_.isEmpty(evts)) {
        self.AnchorMessageProvider.addMessage(msgPlanNotLoaded)
        self.AnchorProgressProvider.finish()
        resolve()
        return
      }

      let arrAnchorGroups: IAnchorGroup[] = []
      let arrAutoAnchors: EventBO[] = []
      let arrManualAnchors: EventBO[] = []
      let arrMerchEvents: EventBO[] = []
      let arrOtherEvents: EventBO[] = []
      let arrDeleteAutoAnchors: EventBO[] = []

      _.forEach(evts, (anEventBO) => {

        // Put Auto Anchors in own List
        if (self.isAutoAnchor(anEventBO)) {
          arrAutoAnchors.push(anEventBO)
          return
        }

        if (self.isAnchor(anEventBO)) {
          // If your a manual anchor, your excluded... I should ignore child events.
          arrManualAnchors.push(anEventBO)
          return
        }


        // Create Anchor Groups from Merch Events
        if (self.isMerchEvent(anEventBO)) {
          let newAG: IAnchorGroup = {
            StartMerchEvent: anEventBO,
            MerchEvents: {},
            OverlappingEvents: {},
            RankMetricValue: 0,
            SourceSyncId: "",
            GroupInStoreRange: self.getInStoreDates(anEventBO),
            GroupProductGroups: [],
            AutoAnchorBO: undefined
          }
          newAG.MerchEvents[anEventBO.WB_Event.cif.WB_EVT_ID] = anEventBO
          arrAnchorGroups.push(newAG)

          arrMerchEvents.push(anEventBO)

        } else {
          arrOtherEvents.push(anEventBO)
        }
      })

      if (_.isEmpty(arrAnchorGroups)) {
        self.AnchorMessageProvider.addMessage(msgNoAnchorGroups)
        self.AnchorProgressProvider.finish()
        resolve()
        return
      }


      //  Determine addition Merch Overlap
      _.forEach([1, 2], (pass) => {  // allow chains to be consolidated.
        _.forEach(arrMerchEvents, (aMerchEvent) => {
          _.forEach(arrAnchorGroups, (anchorGroup) => {

            // Check if already in Anchor Group
            if (aMerchEvent.WB_Event.cif.WB_EVT_ID in anchorGroup.MerchEvents) {
              return
            }

            _.forEach(anchorGroup.MerchEvents, (agMerchEvent) => {
              if (self.eventsOverlap(aMerchEvent, agMerchEvent)) {  //, anchorGroup.StartMerchEvent
                anchorGroup.MerchEvents[aMerchEvent.WB_Event.cif.WB_EVT_ID] = aMerchEvent
                return false
              }
            })
          })
        })
      })

      // Determine Anchor Bounds... InStore Dates/ PGs
      _.forEach(arrAnchorGroups, (anchorGroup) => {
        let dctPGById: { [id: number]: WB_ProductGroupRow } = {}
        let InStoreRange: IDateRange = self.getInStoreDates(anchorGroup.StartMerchEvent)
        anchorGroup.SourceSyncId = _.orderBy(_.map(_.values(anchorGroup.MerchEvents), (evt: EventBO) => {
          return evt.WB_Event.cif.EVENT_ID
        }), (a) => {
          return a
        }).join("-")

        anchorGroup.RankMetricValue = anchorGroup.StartMerchEvent.WB_Event.WB_EventOverrideRow.WB_MetricRow_Actual.cif.SPEND_TOTAL
        _.forEach(anchorGroup.MerchEvents, (aMerchEvent) => {
          InStoreRange = DateUtils.RangeUnion(InStoreRange, self.getInStoreDates(aMerchEvent))
          // Union Promoted Groups
          _.forEach(aMerchEvent.ProductGroups, (aPG) => {
            if (!(aPG.cif.WB_PRDGRP_ID in dctPGById)) {
              dctPGById[aPG.cif.WB_PRDGRP_ID] = aPG
            }
          })
        })

        anchorGroup.GroupInStoreRange = InStoreRange
        anchorGroup.GroupProductGroups = _.values(dctPGById)
      })


      // Eliminate Anchors that ovlerlap Manual Anchors
      let iRemovedAnchorGroupsOverlapManualAnchors = 0
      _.remove(arrAnchorGroups, (anchorGroup) => {
        let bRemove = false

        _.forEach(arrManualAnchors, (aManualAnchor) => {
          if (self.anchorGroupOverlap(anchorGroup, aManualAnchor)) {
            bRemove = true
            iRemovedAnchorGroupsOverlapManualAnchors += 1
            return false
          }
        })

        return bRemove
      })

      if (iRemovedAnchorGroupsOverlapManualAnchors > 0) {
        self.AnchorMessageProvider.addMessage(msgAnchorOverlappingManualAnchors)
      }

      // Add Other Overlapping Events
      _.forEach(arrOtherEvents, (aOtherEventBO) => {
        _.forEach(arrAnchorGroups, (anchorGroup) => {
          if (self.anchorGroupOverlap(anchorGroup, aOtherEventBO)) {
            anchorGroup.OverlappingEvents[aOtherEventBO.WB_Event.cif.WB_EVT_ID] = aOtherEventBO
          }
        })
      })

      // Remove Anchor Groups that don't overlap other events and there is only 1 merch event
      _.remove(arrAnchorGroups, (anchorGroup) => {
        if ((_.keys(anchorGroup.MerchEvents).length == 1) && (_.keys(anchorGroup.OverlappingEvents).length == 0)) {
          return true
        }
        return false
      })


      // Eliminate duplicates Merch Events..  sort by Spend ?
      let AnchorGroupsToKeep: IAnchorGroup[] = []
      _.forEach(_.orderBy(arrAnchorGroups, ['RankMetricValue'], ['desc']), (anchorGroup) => {
        let bOverlaps = false
        _.forEach(AnchorGroupsToKeep, (anOverlapCheckAnchorGroup) => {
          if (self.anchorGroupsOverlap(anchorGroup, anOverlapCheckAnchorGroup)) {
            bOverlaps = true
            return false
          }
        })
        if (!bOverlaps) {
          AnchorGroupsToKeep.push(anchorGroup)
        }
      })
      arrAnchorGroups = AnchorGroupsToKeep

      // Now Create/ Sync AutoAnchors
      _.forEach(arrAutoAnchors, (autoAnchorBO) => {
        let bFoundMatch = false
        _.forEach(arrAnchorGroups, (anchorGroup) => {
          // Generate the Id using the ids of the merch Events

          if (autoAnchorBO.WB_Event.WB_EventOverrideRow.cif.ANCHOR_SYNC_SOURCE == anchorGroup.SourceSyncId) {
            anchorGroup.AutoAnchorBO = autoAnchorBO
            bFoundMatch = true
            return false
          }
        })

        if (!bFoundMatch) {
          // Delete Auto Anchor
          arrDeleteAutoAnchors.push(autoAnchorBO)
        }
      })

      // Check AutoAnchors
      let confirmPromise = ASync.resolve({AnchorGroups: arrAnchorGroups, AutoAnchorDeletes: arrDeleteAutoAnchors})
      if (_.isFunction(opts.ConfirmActions)) {
        confirmPromise = opts.ConfirmActions({AnchorGroups: arrAnchorGroups, AutoAnchorDeletes: arrDeleteAutoAnchors})
      }

      confirmPromise
        .then((results) => {

          // Create/ Sync Anchors for Anchor Groups
          arrDeleteAutoAnchors = results.AutoAnchorDeletes
          arrAnchorGroups = results.AnchorGroups


          async function DeleteAnchors() {
            try {
              for (var idx = 0; idx < arrDeleteAutoAnchors.length; idx++) {
                let deleteAnchor = arrDeleteAutoAnchors[idx]
                if (!_.isEmpty(deleteAnchor)) {
                  self.AnchorMessageProvider.addMessage({
                    type: MessageType.Information,
                    title: "Deleting Anchor " + deleteAnchor.Identity.id_ui,
                    description: "Deleting Anchor " + deleteAnchor.Identity.id_ui + " " + deleteAnchor.Identity.name,
                    code: "Delete"
                  })
                  await deleteAnchor.Delete()
                }
              }
            } catch (err) {
              self.AnchorMessageProvider.addMessage({
                type: MessageType.Error,
                title: "Error Deleting Anchor: " + err,
                description: "Error Deleting Anchor: " + err,
                code: "DeleteError",
                details: err
              })
              throw err
            }

          }

          return DeleteAnchors()

        })
        .then((ignore) => {
          // Sync / Add

          async function SyncCreateAnchors() {
            try {
              for (var idx = 0; idx < arrAnchorGroups.length; idx++) {
                let anchorGroup = arrAnchorGroups[idx]

                // Create Anchor if needed.
                if (_.isEmpty(anchorGroup.AutoAnchorBO)) {
                  self.AnchorMessageProvider.addMessage({
                    type: MessageType.Information,
                    title: "Creating Anchor Group",
                    description: "Creating Anchor Group",
                    code: "Create"
                  })
                  let copyOpts: IEventCopyOptions = {
                    bIncludeEventSubCustomers: true,
                    bIncludeEventProductGroups: true,
                    bIncludeEventTags: true
                  }
                  let newEvent: EventBO
                  newEvent = <any> await anchorGroup.StartMerchEvent.Copy(copyOpts)
                  newEvent.WB_Event.cif.EVENT_NAME = "Anchor: " + newEvent.WB_Event.cif.EVENT_NAME
                  newEvent.WB_Event.WB_EventOverrideRow.cif.ACTUAL_VOL_METHOD_ID = "Anchor"
                  newEvent.WB_Event.WB_EventOverrideRow.cif.ANCHOR_SYNC_POLICY = Auto_Anchor_Policy_Auto
                  newEvent.WB_Event.WB_EventOverrideRow.cif.ANCHOR_SYNC_SOURCE = anchorGroup.SourceSyncId
                  await anchorGroup.StartMerchEvent.OnIHavePlanLoaded
                  anchorGroup.StartMerchEvent.Plan.PlanEvents.addEvent(newEvent)
                  anchorGroup.AutoAnchorBO = newEvent
                  //await newEvent.runAutoAnchoring({})
                }

                let aaEvent = anchorGroup.AutoAnchorBO
                // Sync PGs
                // Add missing PGs
                let dctPGIds = _.keyBy(anchorGroup.GroupProductGroups, (aPG) => {
                  return aPG.cif.WB_PRDGRP_ID
                })
                for (var pgidx = 0; pgidx < anchorGroup.GroupProductGroups.length; pgidx++) {
                  let pg = anchorGroup.GroupProductGroups[pgidx]
                  aaEvent.addProductGroup(pg.cif.WB_PRDGRP_ID)
                }

                // remove extra PGs
                _.forEach(aaEvent.ProductGroups, (aPG) => {
                  if (!(aPG.cif.WB_PRDGRP_ID in dctPGIds)) {
                    aaEvent.removeProductGroup(aPG.cif.WB_PRDGRP_ID)
                  }
                })

                // Sync InStore Dates
                aaEvent.InStore = anchorGroup.GroupInStoreRange

                calcEventsAutoAnchors[aaEvent.WB_Event.cif.WB_EVT_ID] = aaEvent

                _.defaults(calcEventsOther, anchorGroup.MerchEvents, anchorGroup.OverlappingEvents)
              }
            } catch (err) {
              throw err
            }
          }  // end async function

          return SyncCreateAnchors()
        }).then((ignore) => {

        async function CalculateSupportingEvents() {
          try {
            let arrCalcEvents = _.values(calcEventsOther)
            for (var idx = 0; idx < arrCalcEvents.length; idx++) {
              let anEventBO: EventBO = arrCalcEvents[idx]
              await anEventBO.ActualsCalculator.Calculate()
            }
          } catch (err) {
            throw err
          }
        }

        return CalculateSupportingEvents()

      }).then((ignore) => {

        async function SyncAndCalcAnchors() {
          try {
            for (var idx = 0; idx < arrAnchorGroups.length; idx++) {
              let anchorGroup = arrAnchorGroups[idx]
              //
              let arrMechEvents = _.values(anchorGroup.MerchEvents)
              for (var mIdx = 0; mIdx < arrMechEvents.length; mIdx++) {
                let mrchEvent = arrMechEvents[mIdx]
                await self.AutoAnchor_applyEventUsingRules(anchorGroup.AutoAnchorBO, mrchEvent,{bFull: true})
              }

              let arrOverlappingEvents = _.values(anchorGroup.OverlappingEvents)
              for (var oIdx = 0; oIdx < arrOverlappingEvents.length; oIdx++) {
                let otherEvent = arrOverlappingEvents[oIdx]
                await self.AutoAnchor_applyEventUsingRules(anchorGroup.AutoAnchorBO, otherEvent)
              }

              await anchorGroup.AutoAnchorBO.ActualsCalculator.Calculate()

            }
          } catch (err) {
            throw err
          }
        }

        return SyncAndCalcAnchors()
      }).then((ignore) => {
        self.AnchorProgressProvider.finish()
        resolve()
      }).catch((err) => {
        self.AnchorProgressProvider.exception(err)
        self.AnchorMessageProvider.addMessage({
          type: MessageType.Error,
          title: "Error during AutoAnchoring",
          description: "AutoAnchoring Error: " + err,
          code: "AutoAnchorError",
          details: err
        })
        error(err)
      })


    })
  }


  AutoAnchorRules_apply(anEvent: EventBO, options?: IAutoAnchorOptions): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {

      resolve()
    })
  }


  private isMerchEvent(anEventBO: EventBO): boolean {
    let returnValue = false
    _.forEach(this._merchTags, (aTag) => {
      if (anEventBO.hasTag(aTag.cif.WB_TAG_ID)) {
        returnValue = true
        return false
      }
    })

    return returnValue
  }

  private isAutoAnchor(anEventBO: EventBO): boolean {
    return anEventBO.WB_Event.WB_EventOverrideRow.cif.ANCHOR_SYNC_POLICY == Auto_Anchor_Policy_Auto
  }

  private isAnchor(anEventBO: EventBO): boolean {
    return anEventBO.WB_Event.WB_EventOverrideRow.cif.ACTUAL_VOL_METHOD_ID == Actual_Volume_Method_Anchor
  }

  private eventsOverlap(aEventBO: EventBO, bEventBO: EventBO, restrictedPGEvent: EventBO = undefined): boolean {

    if (!DateUtils.RangesOverlap(this.getInStoreDates(aEventBO), this.getInStoreDates(bEventBO))) {
      return false
    }

    let intPGs = _.intersection(_.map(aEventBO.ProductGroups, (a) => {
        return a.cif.WB_PRDGRP_ID
      }),
      _.map(bEventBO.ProductGroups, (a) => {
        return a.cif.WB_PRDGRP_ID
      }))

    if (!_.isUndefined(restrictedPGEvent)) {
      intPGs = _.intersection(intPGs, _.map(restrictedPGEvent.ProductGroups, (a) => {
        return a.cif.WB_PRDGRP_ID
      }))
    }

    return (intPGs.length > 0)

  }

  private getInStoreDates(anEventBO: EventBO): IDateRange {
    return anEventBO.Execution_InStore_Aligned
  }

  private anchorGroupOverlap(anchorGroup: IAnchorGroup, anEventBO: EventBO): boolean {

    if (!DateUtils.RangesOverlap(anchorGroup.GroupInStoreRange, this.getInStoreDates(anEventBO))) {
      return false
    }

    let intPGs = _.intersection(_.map(anEventBO.ProductGroups, (a) => {
        return a.cif.WB_PRDGRP_ID
      }),
      _.map(anchorGroup.GroupProductGroups, (a) => {
        return a.cif.WB_PRDGRP_ID
      }))

    return (intPGs.length > 0)

  }

  private anchorGroupsOverlap(anchorGroupA: IAnchorGroup, anchorGroupB: IAnchorGroup): boolean {

    if (!DateUtils.RangesOverlap(anchorGroupA.GroupInStoreRange, anchorGroupB.GroupInStoreRange)) {
      return false
    }

    let intPGs = _.intersection(
      _.map(anchorGroupA.GroupProductGroups, (a) => {
        return a.cif.WB_PRDGRP_ID
      }),
      _.map(anchorGroupB.GroupProductGroups, (a) => {
        return a.cif.WB_PRDGRP_ID
      }))

    return (intPGs.length > 0)

  }

  private AutoAnchor_applyEventUsingRules(anchorBO: EventBO, srcEventBO: EventBO, options?: any): Promise<void> {
    const self = this

    let opts = options || {}

    async function AutoAnchor_app() {
      let arrEvtSPG = _.filter(srcEventBO.WB_Event.WB_EventSpend_ProductGroupRows, 'isActive')
      let dctEvtSPG = _.keyBy(arrEvtSPG, (a) => {
        return a.cif.WB_EVTSPG_ID
      })

      for (let idx = 0; idx < arrEvtSPG.length; idx++) {
        let evtSPG = arrEvtSPG[idx]
        await anchorBO.addEventRedistributedSpend(evtSPG.cif.WB_EVTSPG_ID, {bManual: true})
      }

      let arrEvtRSPG = _.filter(anchorBO.WB_Event.WB_EventSpend_RedistributionRows,
        (evtRSPG: WB_EventSpendPrdGrpRedistribRow) => {
          return evtRSPG.isActive && (evtRSPG.cif.WB_EVTSPG_ID in dctEvtSPG)
        })

      for (let idx = 0; idx < arrEvtRSPG.length; idx++) {
        let evtRSPG = arrEvtRSPG[idx]
        let evtSPG = evtRSPG.WB_EventSpendPrdGrpRow
        let evt = evtSPG.WB_EventRow

        let aSpendRule = self.FindSpendRule(evt.cif.WB_CUST_ID_PLANNING, evt.cif.EVENT_TYPE_ID, evtSPG.cif.WB_SPENDM_ID, evtSPG.cif.RATE_BASIS_ID)
        if (_.isUndefined(aSpendRule)) {
          if(opts.bFull){
            let domBasisFull = self.FindSpendAllocationDomainItemByItemId("Full")
            if(!_.isEmpty(domBasisFull)) {
              evtRSPG.cif.BASIS_ID = domBasisFull.cif.WB_DOMITEM_ID
            }
          }
          continue;
        }

        switch (true) {

          case ((aSpendRule.cif.SPEND_ALLOCATION_RULE == "Full") || (opts.bFull)):
            let domBasisFull = self.FindSpendAllocationDomainItemByItemId("Full")
            if(!_.isEmpty(domBasisFull)) {
              evtRSPG.cif.BASIS_ID = domBasisFull.cif.WB_DOMITEM_ID
            }
            break;

          case (aSpendRule.cif.SPEND_ALLOCATION_RULE == "Pcnt"):
            let domBasisPcnt = self.FindSpendAllocationDomainItemByItemId("Pcnt")
            if(!_.isEmpty(domBasisPcnt)) {
              evtRSPG.cif.BASIS_ID = domBasisPcnt.cif.WB_DOMITEM_ID
              evtRSPG.cif.BASIS_RATE_AMT = aSpendRule.cif.BASIS_RATE_AMT
            }
            break;

          case (aSpendRule.cif.SPEND_ALLOCATION_RULE == "CnsOvrlp"):
            let domBasisCnsOvrlp = self.FindSpendAllocationDomainItemByItemId("ConsOvrlp")
            if(!_.isEmpty(domBasisCnsOvrlp)) {
              evtRSPG.cif.BASIS_ID = domBasisCnsOvrlp.cif.WB_DOMITEM_ID
            }
            break;

          case (aSpendRule.cif.SPEND_ALLOCATION_RULE == "ShpOvrlp"):
            let domBasisShpOvrlp = self.FindSpendAllocationDomainItemByItemId("ShipOvrlp")
            if(!_.isEmpty(domBasisShpOvrlp)) {
              evtRSPG.cif.BASIS_ID = domBasisShpOvrlp.cif.WB_DOMITEM_ID
            }
            break;

          case (aSpendRule.cif.SPEND_ALLOCATION_RULE == "EvenDistOverlap"):
            break;

          case (aSpendRule.cif.SPEND_ALLOCATION_RULE == "IncrDistOverlap"):
            break;

          default:
        }

      }
    }

    return AutoAnchor_app()
  }

  private FindSpendRule(aWB_CUST_ID_PLANNING: number,
                        aWB_EVTTYPE_ID: number,
                        aWB_SPENDM_ID: number,
                        aRATE_BASIS_ID: string): WB_SpendAllocationRuleItemRow {
    const self = this
    let returnValue: WB_SpendAllocationRuleItemRow = undefined

    _.forEach(self._spendAllocaitonRuleItems, (aRow) => {

      if (!((aWB_CUST_ID_PLANNING == aRow.cif.WB_CUST_ID_PLANNING) || (aRow.cif.WB_CUST_ID_PLANNING == 0))) {
        return
      }

      if (!((aWB_EVTTYPE_ID == aRow.cif.WB_EVTTYPE_ID) || (aRow.cif.WB_EVTTYPE_ID == 0))) {
        return
      }

      if (!((aWB_SPENDM_ID == aRow.cif.WB_SPENDM_ID) || (aRow.cif.WB_SPENDM_ID == 0))) {
        return
      }

      if (!((aRATE_BASIS_ID == aRow.cif.RATE_BASIS_ID) || (aRow.cif.RATE_BASIS_ID == "All"))) {
        return
      }

      returnValue = aRow
      return false

    })


    return returnValue
  }

  private FindSpendAllocationDomainItemByItemId(anId: string): WB_DomainItemRow {
    const self = this

    let returnValue = undefined

    _.forEach(self._spendAllocationDomainItems, (anItem) => {
      if (anItem.cif.DOMAIN_ITEM_ID == anId) {
        returnValue = anItem
        return false
      }
    })

    return returnValue
  }

}
